import { render, staticRenderFns } from "./success_component.vue?vue&type=template&id=0644d3b0&scoped=true&"
import script from "./success_component.vue?vue&type=script&lang=js&"
export * from "./success_component.vue?vue&type=script&lang=js&"
import style0 from "./success_component.vue?vue&type=style&index=0&id=0644d3b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0644d3b0",
  null
  
)

export default component.exports